import React, { forwardRef, ForwardRefRenderFunction } from "react";
//#region types
import { FormEnums } from "models/enums";
import { FormHandles, GenericFormSection } from "models/propTypes/genericFormProps";
import { BusinessUnitFormViewProps } from "models/propTypes/businessUnitPropTypes";
import { BusinessUnitFormTypes } from "models/formTypes";
import { TranslationKeys } from "translations";
//#endregion
//#region  components
import { GenericForm } from "components/common";
import { IconDefinitionConstants, BusinessUnitConstants } from "utils/constants";
import useGeneralInfoFields from "./useGeneralInfoFields";
import useMembersFields from "./useMembersFields";
//#endregion

const BusinessUnitForm: ForwardRefRenderFunction<FormHandles, BusinessUnitFormViewProps> = (props, ref) => {
  const genericInfoFields = useGeneralInfoFields({ ...props, hideGeneralInfoSubHeader: true });
  const membersFields = useMembersFields(props);

  const formFieldsStep1: GenericFormSection<BusinessUnitFormTypes.Create>[] = [
    {
      label: TranslationKeys.BusinessUnit.BusinessUnitInformation,
      type: FormEnums.FormSectionType.WIZARDTAB,
      icon: IconDefinitionConstants.WInfo,
      className: "businessUnitNoTopPadding",
      navKey: BusinessUnitConstants.NavigationKey.BusinessUnitInformation,
      innerFields: genericInfoFields,
    },
  ];

  const formFieldsStep2: GenericFormSection<BusinessUnitFormTypes.Create>[] = [
    {
      label: TranslationKeys.BusinessUnit.Members,
      type: FormEnums.FormSectionType.WIZARDTAB,
      icon: IconDefinitionConstants.WUsers,
      navKey: BusinessUnitConstants.NavigationKey.Members,
      innerFields: membersFields,
    },
  ];

  return (
    <GenericForm
      formRef={ref}
      {...props}
      fields={formFieldsStep1.concat(formFieldsStep2)}
      inline
      hideSuccess
      wizardConfig={{
        showStepIcons: !props.isCreate,
        isSettingsWizard: true,
      }}
    />
  );
};

export default forwardRef(BusinessUnitForm);
